import React from 'react'
import Helmet from 'react-helmet'
import pic01 from '../assets/images/imbibe.jpg'

const Contact = (props) => (
    <div id="contact">
        <Helmet>
            <title>IMBIBE - Contact Us</title>
            <meta name="description" content="Generic Page" />
        </Helmet>

        <div id="main" className="">

            <section id="one">
                <div className="inner">
                    <h1>Contact Us</h1>
                    <p>We would enjoy the opportunity to meet and learn more about your business need. Perhaps we’ll be a good fit to work together, just reach out when you’re ready to start a conversation.</p>


                    <div className="row">
                        <div className="image">
                            <img src={pic01} alt=""/>
                        </div>

                        <div className="details">
                            <section>
                                <div className="contact-method">
                                    <span className="icon alt fa-home"></span>
                                    <span>2035 Manchester St NE #300, <br />
                                      Atlanta, GA 30324<br />
                                      <a href="https://www.google.com/maps/dir/?api=1&destination=2035+Manchester+St+NE+%23300,+Atlanta,+GA+30324" target="_blank">Driving Directions</a> <br />
                                      <a href="http://dev.imbibe.info/images/imbibe-directions.pdf" target="_blank">Download PDF</a>
                                </span>
                                </div>
                            </section>
                            <section>
                                <div className="contact-method">
                                    <span className="icon alt fa-envelope"></span>
                                    <a href="mailto:hello@imbibe.info">hello@imbibe.info</a>
                                </div>
                            </section>
                            <section>
                                <div className="contact-method">
                                    <span className="icon alt fa-phone"></span>
                                    <a href="tel:4048225035">(404) 822-5035</a>
                                </div>
                            </section>
                        </div>
                    </div>




                </div>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3315.0739143657775!2d-84.36523738490091!3d33.81040558067247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f505d04c8771d1%3A0x92ad6d6ca8c8ee81!2sImbibe+Design!5e0!3m2!1sen!2sus!4v1521303930630" width="600" height="450" frameBorder="0"  allowfullscreen></iframe>
            </section>
        </div>

    </div>
)

export default Contact


// WEBPACK FOOTER //
// ./src/pages/contact.js